import React, { useState, FormEvent } from 'react';

interface AuthFormProps {
  onSubmit: (email: string) => void;
  hideTnCBox?: boolean;
  isSubmitting?: boolean;
}

const AuthForm: React.FC<AuthFormProps> = ({
  onSubmit,
  hideTnCBox = false,
  isSubmitting = false,
}) => {
  const [email, setEmail] = useState('');
  const [isChecked, setIsChecked] = useState(false);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!hideTnCBox && !isChecked)
      alert('Please agree to the Terms & Conditions.');
    onSubmit(email);
  };

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-[360px] mx-auto mt-6 sm:mt-8">
      <div className="mb-4">
        <input
          type="email"
          placeholder="name@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-3 border rounded-md bg-white outline-none text-base focus:border-[#6741c6] focus:ring-1 focus:ring-[#6741c6]"
          required
        />
      </div>
      {!hideTnCBox && (
        <div className="flex items-center mb-4">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            className="mr-2 h-5 w-5 cursor-pointer accent-[#6741c6] bg-white"
          />

          <label className="text-sm sm:text-base font-medium">
            I agree to Equitee's Terms & Conditions
          </label>
        </div>
      )}
      <button
        type="submit"
        className={`btn-primary w-full h-12 text-base bg-[#6741c6] hover:bg-[#5536a5] ${(!hideTnCBox && !isChecked) || isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
        disabled={(!hideTnCBox && !isChecked) || isSubmitting}
      >
        {isSubmitting ? 'Continuing...' : 'Continue'}
      </button>
    </form>
  );
};

export default AuthForm;